import React, { Component } from 'react';
import Logo from '../../assets/images/kinship-logo.svg';

export default class ForgotPage extends Component {
    // constructor() {
    //     super()
    // }
    render() {
        return (
            <div className='forgot-password'>
                <div className="container">
                    <div className="forgot-passwordMainDiv" style={{ height: '100%' }}>
                        <div className="LogoDiv">
                            <img src={Logo} alt="logo" />
                        </div>
                        <div className='forgot-password-content-div'>
                            <h4>Forgot Your Password?</h4>
                            <p>Enter your email address and we will send you instructions to reset your password.</p>
                        </div>

                        <form style={{ paddingTop: '10px', textAlign: 'center' }}>
                            <div class="form-group"  >

                                <input type="email" class="form-control-ausi" 
                                id="txtUserForgetEmail" 
                                name="txtUserForgetEmail" 
                                value={this.props.txtUserForgetEmail} 
                                onChange={this.props.HandleForgotPasswordInputs} 
                                onKeyDown={(e)=>this.props.CheckForget(e)}
                                placeholder="Enter email" />

                            </div>
                            {this.props.txtForgotPasswordValidationMessage !== '' ?
                            <div>
                                <div className="ausaf-errorMessage">{this.props.txtForgotPasswordValidationMessage}</div>
                            </div> : null}
                            <button type="button" class="btn login-button" id="btnForgotPasswordButton" name="btnForgotPasswordButton" onClick={this.props.ForgotPassword}>Continue</button>

                            <div className="forgot-password-back cursor-pointer" onClick={() => this.props.HandleRouting("login")}><p>Back to Login</p></div>

                        </form>
                    </div>

                </div>


            </div>
        )
    }
}